import { useCallback, useEffect, useState } from 'react';
import { FiservCardInterface, FiservCardStatusEnum } from '@common-fe/common-fe';

import useCardAccessModalStore from '../stores/useCardAccessModal.store';

export const useCardAccessModal = (
  card?: FiservCardInterface,
  visible?: boolean,
  onChangeCardAccessModalVisible?: () => void,
  setHideVisibility?: (value: boolean) => void,
) => {
  const [isEmployeeUnlockForbidden, setEmployeeUnlockForbidden] = useState(false);
  const [isConfirmationMode, setConfirmationMode] = useState(false);
  const { 
    state: { lockedPursesIds, isCardLocked },
    handleToggleCardLock,
    handleSetLockedPurses
  } = useCardAccessModalStore();

  const handleSetConfirmationMode = useCallback(() => {
    setConfirmationMode((prev) => !prev);
  }, []);
  
  const handleCancel = useCallback(() => {
    onChangeCardAccessModalVisible?.();
    setHideVisibility?.(false);
  }, [onChangeCardAccessModalVisible, setHideVisibility]);

  useEffect(() => {
    if (!visible) {
      setConfirmationMode(false);
    }
  }, [visible]);

  useEffect(() => () => {
    handleToggleCardLock(card?.status === FiservCardStatusEnum.FROZEN || card?.status === FiservCardStatusEnum.PENDING_FROZEN);
    if (card?.cardPurses) handleSetLockedPurses(card.cardPurses);
  }, [card?.cardPurses, card?.status, handleSetLockedPurses, handleToggleCardLock]);

  return {
    isConfirmationMode,
    lockedPursesIds,
    isCardLocked,
    isEmployeeUnlockForbidden,
    handleSetConfirmationMode,
    handleCancel,
    handleEmployeeUnlockForbidden: setEmployeeUnlockForbidden,
  };
};
